export default {
    authUser: ( state ) => {
        return JSON.parse(state.authUser);
    },

    token: ( state ) => {
        return state.token;
    }
}